export default __webpack_public_path__ + "static/media/linkedIn-inverted.0fcbc8cd.png";